import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import ExtraAuth from "../views/ExtraAuth.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
  ,
  {
    path: "/extraauth",
    name: "ExtraAuth",
    component: ExtraAuth,
    props: (route) => ({
      user_id: route.query.user_id,
      key: route.query.key,
      app_id: route.query.app_id,
    })
  },
  
  
];

const router = new VueRouter({
  routes
});

export default router;
